export default {
  default_program_name: 'Club de Rewards',
  message:
    'Únete a <highlight>{{name}}</highlight> — gana {{reward}} por cada {{spend}} gastado y desbloquea artículos gratis del menú!',
  buttons: {
    join_now: 'Unirse ahora',
  },
};
